/** Malay (Bahasa Melayu) translations for UI keys not yet overridden in ms.ts */

export const msFullPatch: Record<string, string | string[][]> = {
  // --- Nav & misc ---
  navFAQ: 'Soalan Lazim',
  navSettings: 'Tip & Strategi',

  lcTitle: 'Listening Comprehension',
  rcTitle: 'Reading Comprehension',
  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  vocabLabel: 'Kosa Kata',
  tipsLabel: 'Tip & Strategi',
  catLabel: 'Ujian Adaptif (CAT)',

  footerCopyright: '© 2026 Power TOEFL. Hak cipta terpelihara.',
  footerDisclaimer:
    'TOEFL® ialah tanda dagangan berdaftar ETS. Power TOEFL tidak berafiliasi dengan ETS dan dikendalikan secara bebas.',

  faqPageTitle: 'Pendaftaran TOEFL · Pengiraan Skor · Tempoh Sah — Soalan Lazim 2026 | Power TOEFL',
  faqPageDesc:
    'Cara daftar TOEFL, penukaran skor, tempoh sah, strategi setiap bahagian — 30 soalan paling kerap ditanya dalam satu halaman.',

  tipsLCButton: 'Strategi Listening',
  tipsRCButton: 'Strategi Reading',
  tipsDetailStrategy: 'Strategi Terperinci',
  tipsCoreTips: 'Tip Utama',
  tipsStrategy: 'Strategi Ujian',
  tipsCTA: 'Sudah faham strategi? Mula latihan!',

  footer7DayPlan: 'Pelan 7 Hari',
  footerTrapPatterns: 'Corak Perangkap',

  // --- Practice pages ---
  practiceRelatedLinks: '📌 Kandungan Berkaitan',
  practiceOtherParts: 'Strategi Bahagian Lain',
  practiceMockTestCTA: 'Latih dengan Simulasi Ujian',
  practiceTipsLink: 'Lihat Strategi Setiap Bahagian',
  practiceGrammarLink: 'Belajar Tatabahasa',
  practiceNotFound: 'Bahagian tidak dijumpai.',
  practiceQuestionType: 'Jenis Soalan',
  practiceTips: '💡 Tip Strategi',
  practiceExamples: '📝 Contoh Soalan',
  practiceIntro: '📋 Pengenalan Bahagian',
  practiceCommonTypes: '📊 Jenis Soalan Kerap',
  practiceStrategy: '🎯 Titik Strategi',
  practiceRecommendedFor: '👤 Disyorkan Untuk',
  practiceFAQ: '❓ Soalan Lazim',
  practiceCTA: 'Mula Latihan Sekarang',
  practiceCTADesc: 'Latih Bahagian {0} dalam keadaan seperti ujian sebenar.',
  practiceStartTest: 'Mula Simulasi {0}',
  practiceQuestions: 'soalan',
  practicePartSelect: 'Pilih Bahagian',

  roundsTitle: 'Set Simulasi Ujian',
  roundUnit: '',
  comingSoon: 'Akan Datang',

  // --- Test flow ---
  testLoginPrompt: 'Nota kesilapan & sambung ujian memerlukan log masuk.',
  testGoogleLogin: 'Teruskan dengan Google dalam 3 saat',
  roundSelect: 'Pilih pusingan lain',
  testAnswered: 'Dijawab',
  testSubmitTitle: 'Hantar ujian {0}?',
  testSubmitDesc: 'Anda telah jawab {1} daripada {0} soalan.',
  testUnanswered: '{0} soalan belum dijawab.',
  testCannotUndo: 'Tindakan ini tidak boleh dibatalkan.',
  testSubmitBtn: 'Hantar',
  testScrollHint: 'Tatal untuk lihat soalan dan pilihan',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: 'Dengar audio dan pilih jawapan',
  testPart3Label: 'Lectures',

  // --- Results ---
  resultsAccuracy: 'Ketepatan',
  resultsReview: 'Semak Jawapan',
  resultsYourAnswer: 'Jawapan anda: {0}',
  resultsCorrectAnswer: 'Jawapan betul: {0}',
  resultsNoAnswer: 'Tiada jawapan',
  resultsHome: 'Laman Utama',
  resultsWrongNotes: 'Nota Kesilapan',
  resultsRetry: 'Cuba Lagi',
  resultsShare: 'Kongsi Keputusan',
  resultsShareText:
    'Skor anggaran TOEFL {0} saya ialah {1}! ({2}/{3} betul, ketepatan {4}%) Cuba percuma di Power TOEFL!',
  resultsShareCopied: 'Keputusan disalin ke papan keratan!',
  resultsNoResults: 'Tiada keputusan ujian.',
  resultsGoHome: 'Ke Laman Utama',
  resultsSaved: '{0} jawapan salah disimpan ke nota kesilapan',

  // --- Wrong answers ---
  wrongAnswersTitle: 'Nota Kesilapan',
  wrongAnswersSaved: 'Soalan Disimpan',
  wrongAnswersHome: 'Laman Utama',
  wrongAnswersPracticeAll: 'Latih Semua',
  wrongAnswersAll: 'Semua',
  wrongAnswersNoItems: 'Belum ada jawapan salah. Ambil ujian dahulu!',
  wrongAnswersYourAnswer: 'Jawapan anda: {0}',
  wrongAnswersCorrectIs: 'Jawapan betul: {0}',
  wrongAnswersReviewed: 'Sudah Disemak',
  wrongAnswersRemoved: 'Dibuang dari nota kesilapan',
  wrongAnswersPracticeMode: 'Mod Latihan',
  wrongAnswersCorrectMsg: 'Betul!',
  wrongAnswersIncorrectMsg: 'Salah. Jawapan betul: {0}',
  wrongAnswersNextQuestion: 'Soalan Seterusnya',
  wrongAnswersFinish: 'Selesai',
  wrongAnswersExitPractice: 'Keluar Latihan',
  wrongAnswersPracticeComplete: 'Latihan Selesai!',
  wrongAnswersNoPractice: 'Tiada soalan untuk dilatih',
  wrongAnswersLimitNotice: 'Hanya 500 jawapan salah terkini dipaparkan.',
  wrongAnswersGrammarAI: 'Tatabahasa AI',

  // --- Privacy ---
  privacyPageTitle: 'Dasar Privasi — Power TOEFL',
  privacyPageDesc: 'Dasar privasi Power TOEFL.',
  privacyHeading: 'Dasar Privasi',
  privacyLastUpdated: 'Kemas kini terakhir: 29 Mac 2026',
  privacyS1Title: '1. Maklumat Dikumpul',
  privacyS1Body:
    'Power TOEFL mengumpul e-mel, nama, dan foto profil semasa log masuk Google. Maklumat pembayaran diproses melalui Dodo Payments/PayPal.',
  privacyS2Title: '2. Tujuan Penggunaan',
  privacyS2Body:
    'Data digunakan untuk nota kesilapan, pengurusan kemajuan belajar, langganan, dan penambahbaikan perkhidmatan.',
  privacyS3Title: '3. Penyimpanan dan Pemadaman',
  privacyS3Body:
    'Data dipadam apabila akaun ditutup. Rekod pembayaran disimpan sehingga 5 tahun mengikut undang-undang cukai.',
  privacyS4Title: '4. Perkongsian dengan Pihak Ketiga',
  privacyS4Body: 'Hanya e-mel dikongsi dengan Dodo Payments/PayPal untuk pemprosesan pembayaran.',
  privacyS5Title: '5. Kuki dan Iklan',
  privacyS5Body:
    'Laman ini menggunakan Google AdSense dan kuki berkaitan. Tetapan kuki boleh diurus dalam pelayar.',
  privacyS6Title: '6. Pemindahan Data Antarabangsa',
  privacyS6Body:
    'Data mungkin dipindahkan antarabangsa melalui pelayan luar negara dengan langkah keselamatan yang mencukupi.',
  privacyS7Title: '7. Hak Pengguna',
  privacyS7Body: 'Pengguna boleh meminta akses, pembetulan, atau pemadaman data pada bila-bila masa.',
  privacyS8Title: '8. Hubungi',
  privacyS8Body: 'Hubungi: skdaks0731@gmail.com',

  // --- Terms ---
  termsPageTitle: 'Terma Perkhidmatan — Power TOEFL',
  termsPageDesc: 'Terma perkhidmatan Power TOEFL.',
  termsHeading: 'Terma Perkhidmatan',
  termsLastUpdated: 'Kemas kini terakhir: 29 Mac 2026',
  termsS1Title: '1. Gambaran Perkhidmatan',
  termsS1Body:
    'Power TOEFL ialah platform belajar TOEFL dalam talian yang dikendalikan oleh ddookddak (nama perniagaan berdaftar kami), dengan ciri percuma dan premium (Pro/Lifetime).',
  termsS2Title: '2. Syarat Penggunaan',
  termsS2Body: 'Perkhidmatan tersedia untuk pengguna berumur 14 tahun ke atas. Sesetengah ciri memerlukan log masuk Google.',
  termsS3Title: '3. Hak Harta Intelek',
  termsS3Body: 'Kandungan laman (soalan, reka bentuk, kod) milik Power TOEFL. TOEFL ialah tanda dagangan ETS.',
  termsS4Title: '4. Pembayaran',
  termsS4Body: 'Langganan premium diproses melalui Dodo Payments/PayPal. Harga mungkin termasuk cukai.',
  termsS5Title: '5. Penafian',
  termsS5Body: 'Skor simulasi adalah anggaran dan tidak menjamin keputusan ujian TOEFL sebenar.',
  termsS6Title: '6. Tindakan Dilarang',
  termsS6Body: 'Dilarang menyalin/mengedarkan soalan, membebankan sistem, atau berkongsi akaun.',
  termsS7Title: '7. Perubahan Perkhidmatan',
  termsS7Body: 'Perkhidmatan boleh diubah atau dihentikan tanpa notis terlebih dahulu.',
  termsS8Title: '8. Pembatalan Langganan',
  termsS8Body:
    'Langganan boleh dibatalkan pada bila-bila masa. Ciri premium kekal aktif sehingga tempoh tamat.',
  termsS9Title: '9. Perubahan Terma',
  termsS9Body:
    'Terma boleh berubah dan akan diumumkan di laman. Penggunaan berterusan dianggap persetujuan.',

  // --- Refund ---
  refundPageTitle: 'Dasar Bayaran Balik — Power TOEFL',
  refundPageDesc: 'Dasar bayaran balik langganan premium Power TOEFL.',
  refundHeading: 'Dasar Bayaran Balik',
  refundLastUpdated: 'Kemas kini terakhir: 15 April 2026',
  refundS1Title: '1. Skop',
  refundS1Body: 'Terpakai untuk langganan Pro dan Ultra Power TOEFL.',
  refundS2Title: '2. Tempoh dan Peratus Bayaran Balik',
  refundS2Body:
    'Disebabkan sifat produk digital, bayaran balik pada asasnya tidak tersedia. Namun, bayaran balik boleh diberi secara pengecualian jika diwajibkan undang-undang, berlaku bayaran berganda, perkhidmatan tidak diberikan, atau gangguan teknikal besar.',
  refundS3Title: '3. Prosedur',
  refundS3Body:
    'Anda boleh memohon bayaran balik terus melalui Dodo Payments menggunakan pautan dalam e-mel resit pembelian dari Dodo Payments. Atau mohon dari halaman Langganan Saya, atau e-mel ke skdaks0731@gmail.com dengan alamat e-mel dan tarikh pembayaran.',
  refundS4Title: '4. Pengecualian',
  refundS4Body:
    'Permohonan bayaran balik dinilai kes demi kes. Kecuali diwajibkan undang-undang, kami boleh menolak bayaran balik jika perkhidmatan telah digunakan secara substansial.',
  refundS5Title: '5. Ringkasan',
  refundS5Body: '',
  refundS6Title: '6. Hubungi',
  refundS6Body: 'Hubungi: skdaks0731@gmail.com. Respons dalam 1–2 hari bekerja.',

  // --- Footer links ---
  footerPrivacy: 'Privasi',
  footerTerms: 'Terma',
  footerRefund: 'Bayaran Balik',
  footerAbout: 'Tentang Kami',
  footerGuide: 'Panduan Belajar',

  // --- Resume & timer ---
  resumeTest: 'Sambung Ujian',
  resumeDesc: '{0} Pusingan {1} — {2}/{3} soalan',
  progressLabel: 'Kemajuan',
  timerLabel: 'Masa berbaki',
  timeUp: 'Masa tamat!',

  // --- Nav extras ---
  navReview: 'Semakan',
  navStats: 'Statistik',
  navSubscription: 'Urus Langganan',

  // --- Grammar ---
  grammarChapter: 'Bab',
  grammarSystematic: 'Belajar Tatabahasa Secara Sistematik',
  grammarBookTitle: 'Buku Tatabahasa TOEFL',
  grammarBookDesc:
    'Pelajari 20 topik tatabahasa TOEFL secara sistematik. Setiap bab dilengkapi contoh dan latihan.',
  grammarTestAfter: 'Uji selepas belajar tatabahasa!',
  grammarTestAfterDesc: 'Lihat bagaimana tatabahasa muncul dalam soalan TOEFL sebenar',
  grammarMockTest: 'Simulasi Ujian',
  grammarDoneTitle: 'Selesai belajar tatabahasa?',
  grammarDoneDesc: 'Gunakan dalam simulasi ujian. Jawapan salah disimpan automatik!',
  grammarStartRC: 'Mula Simulasi Reading',
  grammarPracticePart5: 'Latihan Tatabahasa',
  grammarCourseName: 'Tatabahasa TOEFL Lengkap',
  grammarBreadcrumb: 'Buku Tatabahasa',
  grammarHome: 'Laman Utama',
  grammarExamples: 'Contoh Ayat',
  grammarTestKnowledge: '📝 Uji Pemahaman',
  grammarTestKnowledgeDesc: 'Jawab soalan berkaitan tatabahasa yang baru dipelajari!',
  grammarCheckAnswers: 'Semak Jawapan',
  grammarPerfect: '🎉 Semua Betul!',
  grammarCorrectCount: 'Betul',
  grammarMockCTA: '🔥 Uji kemampuan dalam simulasi ujian!',
  grammarMockCTADesc: 'Reading 100 soalan + nota kesilapan automatik',
  grammarStartRCMock: 'Mula Simulasi Reading',
  grammarPractice5: 'Latihan Tatabahasa',
  grammarTestInPractice: 'Semak dalam soalan sebenar!',
  grammarTestInPracticeDesc: 'Lihat bagaimana topik tatabahasa muncul dalam TOEFL.',
  grammarRelated: '📚 Tatabahasa Berkaitan',

  // --- AI practice ---
  aiPracticeTitle:
    'Penjana Soalan AI TOEFL — Pilih Bahagian & Tahap, Soalan Baru Setiap Hari | Power TOEFL',
  aiPracticeDesc:
    'Pilih bahagian dan tahap kesukaran, AI terus jana soalan TOEFL baru. Latihan tanpa had setiap hari.',
  aiPracticeH1: '✨ Penjana Soalan AI TOEFL',
  aiPracticeSub: 'AI menjana soalan TOEFL mengikut tahap anda secara masa nyata.',
  aiPartLabel: 'Bahagian',
  aiDiffLabel: 'Tahap',
  aiBeginner: 'Pemula (400~550)',
  aiIntermediate: 'Pertengahan (600~750)',
  aiAdvanced: 'Lanjutan (800~990)',
  aiGenerate: 'Jana Soalan',
  aiGenerating: 'Menjana...',
  aiRemainingToday: 'Baki {0} bulan ini',
  aiLimitReached: 'Kredit AI bulan ini habis',
  aiLimitUpgrade: 'Beli kredit tambahan atau naik taraf pelan!',
  aiUpgrade: 'Naik Taraf',
  aiListenPrompt: '🔊 Soalan Listening — dengar audio semasa menjawab',
  aiPlayAudio: 'Main Audio',
  aiStopAudio: 'Henti',
  aiCorrect: '✅ Betul!',
  aiWrong: '❌ Salah.',
  aiCorrectAnswer: 'Jawapan betul: {0}',
  aiPrev: 'Sebelum',
  aiNext: 'Seterusnya',
  aiNewQuestions: 'Soalan Baru',
  aiEmptyTitle: 'Jana soalan dengan AI',
  aiEmptyDesc: 'Pilih bahagian dan tahap, kemudian klik "Jana Soalan".',
  aiLoadingMain: 'AI sedang menjana dan mengesahkan soalan...',
  aiLoadingSub: 'Kira-kira 10~20 saat',

  // --- AI quiz ---
  aiQuizTitle: '🤖 Kuiz AI',
  aiQuizDesc: 'Soalan Tatabahasa TOEFL dijana AI',
  aiQuizGenerateDesc: 'AI menjana 5 soalan Tatabahasa TOEFL mengikut topik secara masa nyata.',
  aiQuizGenerate: 'Jana Soalan AI',
  aiQuizGenerating: '🤖 AI sedang menjana soalan...',
  aiQuizGeneratingTime: 'Kira-kira 5~10 saat',
  aiQuizNew: 'Soalan Baru',
  aiQuizStats: 'Statistik:',
  aiQuizTimes: 'kali',
  aiQuizCheckAnswers: 'Semak Jawapan',
  aiQuizPerfect: '🎉 Semua Betul!',
  aiQuizCorrectCount: 'Betul',
  aiQuizSaving: 'Menyimpan keputusan...',
  aiQuizTryNew: 'Cuba Soalan Baru',
  aiQuizError: 'Gagal menjana soalan AI. Cuba lagi.',

  // --- Stats ---
  statsLoginPrompt: 'Log masuk untuk lihat statistik pembelajaran.',
  statsTotalQuizzes: 'Jumlah Kuiz',
  statsTotalQuestions: 'Jumlah Soalan',
  statsAccuracy: 'Ketepatan',
  statsLast7Days: '7 Hari Terakhir',
  statsWrongSummary: 'Status Nota Kesilapan',
  statsViewAll: 'Lihat Nota Kesilapan',
  statsTotalWrong: 'Jumlah Salah',
  statsReviewed: 'Sudah Disemak',
  statsPending: 'Belum Disemak',
  statsTopicAccuracy: 'Ketepatan Setiap Topik Tatabahasa',
  statsAttempts: '{0} kali',
  statsEmpty: 'Belum ada rekod pembelajaran. Cuba kuiz tatabahasa!',
  statsStartGrammar: 'Mula Belajar Tatabahasa',

  // --- Pricing ---
  pricingSaveBadge: 'Jimat 30%',
  pricingPerMonth: '/bulan',
  pricingSSL: 'Pembayaran selamat',
  pricingCurrentPlan: 'Pelan semasa',
  pricingFaqQ1: 'Apakah perbezaan Percuma dan Pro?',
  pricingFaqA1:
    'Pelan percuma menyediakan soalan Reading·Listening asas dan 1x AI/hari. Pro merangkumi AI tanpa had, maklum balas AI untuk Bertutur·Penulisan, analisis 4 kemahiran, dan tanpa iklan.',
  pricingFaqQ2: 'Bolehkah saya minta bayaran balik?',
  pricingFaqA2: 'Disebabkan sifat produk digital, bayaran balik pada asasnya tidak tersedia. Namun, bayaran balik boleh diberi secara pengecualian jika diwajibkan undang-undang, berlaku bayaran berganda, perkhidmatan tidak diberikan, atau gangguan teknikal besar.',
  pricingFaqQ3: 'Bagaimana batalkan langganan?',
  pricingFaqA3:
    'Anda boleh batalkan pada bila-bila masa di halaman Langganan Saya. Selepas batal, masih boleh digunakan sehingga tempoh tamat.',
  pricingFaqQ4: 'Apakah perbezaan Lifetime dan Pro tahunan?',
  pricingFaqA4: 'Lifetime bayar sekali untuk selamanya. Pro tahunan perlu diperbaharui setiap tahun.',
  pricingCard: 'Kad kredit',
  pricingPaymentSuccess: 'Premium berjaya diaktifkan!',
  pricingPaymentCancelled: 'Pembayaran dibatalkan.',
  pricingLoginRequired: 'Log masuk diperlukan.',
  pricingPaymentError: 'Gagal mencipta pembayaran.',

  subLoginRequired: 'Log masuk diperlukan.',

  // --- Test LC/RC meta ---
  testLCTitle:
    'Latihan Soalan TOEFL Listening Percuma — Conversations·Lectures Lengkap | 2026',
  testLCDesc:
    'Latihan soalan TOEFL Listening percuma. Conversations dan Lectures dengan audio TTS. Mirip ujian sebenar.',
  testRCTitle: 'Latihan Soalan TOEFL Reading Percuma — Reading Lengkap | 2026',
  testRCDesc:
    'Latihan soalan TOEFL Reading percuma. Academic Reading dengan penjelasan AI.',

  // --- Review (Ebbinghaus) ---
  reviewTitle: 'Semakan Hari Ini',
  reviewDesc: 'Sistem semakan pintar berasaskan lengkung lupa Ebbinghaus',
  reviewSubtitle: 'Semak pada masa optimum mengikut lengkung lupa',
  reviewRemaining: 'Baki Semakan',
  reviewProgress: 'Kemajuan Semakan',
  reviewCompleted: '🎉 Semakan Hari Ini Selesai!',
  reviewCompletedDesc: 'Sudah semak {0} soalan',
  reviewEmpty: 'Tiada soalan untuk disemak hari ini',
  reviewEmptyDesc: 'Semua semakan selesai atau belum ada nota kesilapan.',
  reviewStage: 'Tahap {0}',
  reviewNextInterval: 'Selang {0} hari',
  reviewCorrect: 'Betul! Terus ke tahap seterusnya.',
  reviewWrong: 'Salah. Kembali ke tahap 1.',
  reviewNextReview: 'Semakan seterusnya: {0} hari lagi',
  reviewResetMsg: 'Salah, semak semula dalam 1 hari.',
  reviewNext: 'Soalan Seterusnya',
  reviewFinish: 'Selesai',
  reviewHowItWorks: 'Prinsip Semakan Ebbinghaus',
  reviewDaysLater: '{0} hari kemudian',
  reviewExplanation:
    'Soalan salah disemak dengan selang 1 → 3 → 7 → 14 → 30 → 60 hari. Betul = naik tahap, salah = kembali ke tahap 1.',
  reviewItems: '',
  reviewTodayLabel: 'Soalan semakan hari ini',
  reviewGoLabel: '📚 Mula Semakan →',

  // --- Notifications ---
  notifTitle: 'Pemberitahuan',
  notifEmpty: 'Tiada pemberitahuan baharu',
  notifMarkAllRead: 'Tandai sudah dibaca',
  timeJustNow: 'baru sahaja',
  timeMinutes: '{0} minit lalu',
  timeHours: '{0} jam lalu',
  timeDays: '{0} hari lalu',
  scoreCardEstimated: 'Skor Anggaran',
  scoreCardCorrect: 'Betul',
  scoreCardIncorrect: 'Salah',
  scoreCardAccuracy: 'Ketepatan',

  // --- Push notifications ---
  pushTitle: 'Aktifkan Pemberitahuan Belajar',
  pushDesc: 'Dapatkan peringatan semakan dan rentetan belajar.',
  pushEnable: 'Aktifkan',

  // --- PWA ---
  pwaAddToHome: '📱 Tambah ke Skrin Utama',
  pwaAddToHomeDesc: 'Jalankan seperti aplikasi! Belajar luar talian juga boleh',
  pwaInstall: 'Pasang',
  pwaIOSGuide: 'Kongsi → Tambah ke Skrin Utama',

  // --- Streak ---
  streakDays: 'hari',
  streakLabel: 'Rentetan Belajar',
  streak7: 'Rentetan 1 minggu!',
  streak14: 'Rentetan 2 minggu!',
  streak30: 'Hebat! Rentetan 1 bulan!',

  // --- Leaderboard ---
  leaderboardTitle: 'Kedudukan Belajar',
  leaderboardWeekly: 'Mingguan',
  leaderboardMonthly: 'Bulanan',
  leaderboardLoading: 'Memuatkan...',
  loadingQuestions: 'Memuatkan soalan...',
  leaderboardEmpty: 'Belum ada data {period} ini',
  leaderboardEmptyWeek: 'minggu',
  leaderboardEmptyMonth: 'bulan',
  leaderboardHint: 'Selesaikan ujian untuk masuk kedudukan!',
  leaderboardRank: 'Kedudukan',
  leaderboardNickname: 'Nama',
  leaderboardSolved: 'Soalan',
  leaderboardAccuracy: 'Ketepatan',
  leaderboardMe: 'Saya',
  leaderboardMyRank: '🏅 Kedudukan saya: #{rank}',

  // --- Speaking ---
  speakingPageH1: 'Latihan TOEFL Bertutur 2026',
  speakingPageSub:
    '{count}+ soalan Bertutur percuma — Listen and Repeat · Interview',
  speakingPageTitle:
    'Latihan TOEFL Bertutur 2026 — {count}+ soalan percuma | Power TOEFL',
  speakingPageDesc:
    'Latihan TOEFL Bertutur {count}+. Contoh jawapan, rubrik penilaian, maklum balas AI. 2026.',
  speakingAllTasks: 'Semua',
  speakingNoPrompts: 'Belum ada soalan Bertutur',
  speakingNoPromptsSub: 'Soalan sedang dijana. Sila semak semula nanti!',
  speakingResponseTime: 'Masa respons',

  // --- Writing ---
  writingPageH1: 'Latihan TOEFL Penulisan 2026',
  writingPageSub:
    '{count}+ tugasan Penulisan percuma — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'Latihan TOEFL Penulisan 2026 — {count}+ tugasan percuma | Power TOEFL',
  writingPageDesc:
    'Latihan TOEFL Penulisan {count}+. Contoh jawapan, rubrik penilaian. 2026.',
  writingAllTasks: 'Semua',
  writingNoPrompts: 'Belum ada soalan Penulisan',
  writingNoPromptsSub: 'Soalan sedang dijana. Sila semak semula nanti!',

  // --- Credits ---
  creditBuyBtn: 'Beli Kredit',
  creditBuyTitle: 'Beli Kredit AI',
  creditBuyDesc:
    'Beli kredit tambahan untuk maklum balas AI Bertutur/Penulisan dan latihan AI.',
  creditBuyError: 'Gagal memulakan pembayaran',
  creditBuyNote: 'Pembayaran melalui PayPal. Kredit ditambah terus selepas pembayaran.',
  creditUnit: 'kredit',

  // --- Vocab flashcards ---
  vocabFlashcardStart: 'Mula Kad Imbas',
  vocabFlashcardStop: 'Hentikan Kad Imbas',
  vocabFlashcardEmpty: 'Tambah perkataan dahulu untuk mula kad imbas.',
  vocabFlashcardSpeed: 'Kelajuan',
  vocabFlashcardSpeedSlow: 'Perlahan',
  vocabFlashcardSpeedNormal: 'Normal',
  vocabFlashcardSpeedFast: 'Laju',
  vocabFlashcardShuffle: 'Kocok',
  vocabFlashcardPrev: 'Sebelum',
  vocabFlashcardNext: 'Seterusnya',
  vocabFlashcardFlip: 'Balik',
  vocabFlashcardProgress: '{current} / {total}',
};
